// Moroccan Public Holidays 2026
// Includes both Islamic holidays and national holidays

export const moroccanHolidays2026 = [
    // National Holidays
    { name: "New Year's Day", date: new Date(2026, 0, 1), type: "national" },
    { name: "Independence Manifesto Day", date: new Date(2026, 0, 11), type: "national" },
    { name: "Labor Day", date: new Date(2026, 4, 1), type: "national" },
    { name: "Throne Day", date: new Date(2026, 6, 30), type: "national" },
    { name: "Oued Ed-Dahab Day", date: new Date(2026, 7, 14), type: "national" },
    { name: "Revolution Day", date: new Date(2026, 7, 20), type: "national" },
    { name: "Youth Day", date: new Date(2026, 7, 21), type: "national" },
    { name: "Green March Day", date: new Date(2026, 10, 6), type: "national" },
    { name: "Independence Day", date: new Date(2026, 10, 18), type: "national" },

    // Islamic Holidays (2026 - approximate dates based on lunar calendar)
    // Note: Islamic dates may vary by 1-2 days depending on moon sighting

    // Ramadan 2026 (approximately Feb 17 - Mar 19)
    { name: "First Day of Ramadan", date: new Date(2026, 1, 17), type: "islamic" },

    // Eid al-Fitr (approximately Mar 19-21)
    { name: "Eid al-Fitr", date: new Date(2026, 2, 19), type: "islamic" },
    { name: "Eid al-Fitr (Day 2)", date: new Date(2026, 2, 20), type: "islamic" },

    // Eid al-Adha (approximately May 27-29)
    { name: "Eid al-Adha", date: new Date(2026, 4, 27), type: "islamic" },
    { name: "Eid al-Adha (Day 2)", date: new Date(2026, 4, 28), type: "islamic" },

    // Islamic New Year (approximately Jun 17)
    { name: "Islamic New Year (Muharram)", date: new Date(2026, 5, 17), type: "islamic" },

    // Mawlid al-Nabi (Prophet's Birthday) (approximately Aug 26)
    { name: "Prophet's Birthday (Mawlid)", date: new Date(2026, 7, 26), type: "islamic" },
];

// Get holidays for a specific month/year
export const getHolidaysForMonth = (month, year) => {
    return moroccanHolidays2026.filter(holiday =>
        holiday.date.getMonth() === month &&
        holiday.date.getFullYear() === year
    );
};

// Check if a specific date is a holiday
export const isHoliday = (day, month, year) => {
    return moroccanHolidays2026.some(holiday =>
        holiday.date.getDate() === day &&
        holiday.date.getMonth() === month &&
        holiday.date.getFullYear() === year
    );
};

// Get holiday info for a specific date
export const getHolidayInfo = (day, month, year) => {
    return moroccanHolidays2026.find(holiday =>
        holiday.date.getDate() === day &&
        holiday.date.getMonth() === month &&
        holiday.date.getFullYear() === year
    );
};
